/* Step 12-F4 · lane GC (owner card "AZEX Step 12 Follow-up Add-on Card V2", item G9 — the Final Analytical Review is stored and
   refreshed in the background). EN + AR of what the review screen says while its stored figures are refreshed. The
   "Updating… (figures as of …)" / "Updating… (figures not calculated yet)" / "Refresh queued …" lines are the dashboard's own
   (1610_sb_c.js, sbC.*), so the two screens say it the same way. No standard paragraph is quoted. */
const I18N_S12G_FAR_STORE = {
  en: {
    farStore: {
      failed: "The figures could not be updated. The figures shown are the last ones calculated. Press Refresh to try again.",
      failedNew: "The figures could not be calculated. Press Refresh to try again.",
      pendingHint: "The review opens as soon as its figures are calculated. You can leave this page; they are calculated in the background.",
    },
  },
  ar: {
    farStore: {
      failed: "تعذر تحديث الأرقام. الأرقام المعروضة هي آخر أرقام محسوبة. اضغط «تحديث» للمحاولة مرة أخرى.",
      failedNew: "تعذر احتساب الأرقام. اضغط «تحديث» للمحاولة مرة أخرى.",
      pendingHint: "تُفتح المراجعة فور احتساب أرقامها. يمكنك مغادرة هذه الصفحة؛ فالأرقام تُحتسب في الخلفية.",
    },
  },
};

export default I18N_S12G_FAR_STORE;
